import { render, staticRenderFns } from "./add-userCourse.vue?vue&type=template&id=5287c154&scoped=true&"
import script from "./add-userCourse.vue?vue&type=script&lang=js&"
export * from "./add-userCourse.vue?vue&type=script&lang=js&"
import style0 from "./add-userCourse.vue?vue&type=style&index=0&id=5287c154&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5287c154",
  null
  
)

export default component.exports